import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import TableContainer from '../../common/Tablecontainer';

const EventTransactionReport = () => {
    

    const [searchQuery, setSearchQuery] = useState('');
    const [filterType, setFilterType] = useState('All');
    const [eventName, setEventName] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [tableKey, setTableKey] = useState(0);
    const [list, setList] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);

    const [mobilePage, setMobilePage] = useState(1);
    const [mobileTotalPages, setMobileTotalPages] = useState(1);

    const [isMobile, setIsMobile] = useState(
        window.innerWidth < 768
    );

   useEffect(() => {

        const resize = () => {

            setIsMobile(window.innerWidth < 768);

        };

        window.addEventListener("resize", resize);

        return () =>
            window.removeEventListener("resize", resize);

    }, []);
    const handleSearch = (e) => {

        if (e) e.preventDefault();

        setTableKey(prev => prev + 1);

        if (isMobile) {

            setMobilePage(1);

            loadEventTransactions(
                1,
                searchQuery
            );

        }

    };
    const loadEventTransactions = async (
        page = mobilePage,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const res = await API.get(
                `admin/event-payments/`,
                {
                    params: {
                        page,
                        search,
                        status: filterType,
                        event_name: eventName,
                        from_date: fromDate,
                        to_date: toDate
                    }
                }
            );

            setList(
                Array.isArray(res.data)
                    ? res.data
                    : (res.data.results || [])
            );

            setMobileTotalPages(
                res.data.count
                    ? Math.ceil(res.data.count / 10)
                    : 1
            );
        } catch (err) {

            console.log(err);

        } finally {

            setLoadingCards(false);

        }

    };
    useEffect(() => {

    if (!isMobile) return;

    loadEventTransactions(1, searchQuery);

}, []);

useEffect(() => {

    if (!isMobile) return;

    const timer = setTimeout(() => {

        setMobilePage(1);

        loadEventTransactions(
            1,
            searchQuery
        );

    }, 400);

    return () => clearTimeout(timer);

}, [
    searchQuery,
    filterType,
    eventName,
    fromDate,
    toDate
]);

useEffect(() => {

    if (!isMobile) return;

    loadEventTransactions(
        mobilePage,
        searchQuery
    );

}, [mobilePage]);
    const handlePrintGridAction = () => {
        window.print();
    };
    

    const tableHeaders = ['Date', 'Order ID', 'User Email', 'Event Name', 'Event ID', 'Amount (INR)', 'Status'];

    return (
        <div className="p-6 bg-[#F8FAFC] min-h-screen w-full font-sans animate-fadeIn">
            <h2 className="text-center text-4xl font-light text-gray-700 mb-6">Events Payment Report</h2>

            {/* Filters Section */}
            <form onSubmit={handleSearch} className="w-full bg-white border border-gray-300 px-6 pb-6 pt-2 rounded relative shadow-sm mb-6">
                <span className="absolute -top-2.5 left-4 bg-[#F8FAFC] px-2 text-[11px] font-bold text-gray-700 tracking-wide">
                    Events Report Filters
                </span>
                
                <div className="grid grid-cols-1 md:grid-cols-4 gap-6 items-center text-xs font-bold uppercase text-gray-700 pt-4 w-full">
                    <div className="flex flex-col md:flex-row gap-2">
                        <label className="w-[30%] text-right">Status:</label>
                        <select className="flex-1 p-2 border border-gray-300 rounded-md outline-none bg-gray-50 h-9" 
                                value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                            <option value="All">All</option>
                            <option value="SUCCESS">Success</option>
                            <option value="PENDING">Pending</option>
                        </select>
                    </div>

                    <div className="flex flex-col md:flex-row gap-2">
                        <label className="w-full md:w-[30%] text-left md:text-right">Event:</label>
                        <input type="text" className="flex-1 p-2 border rounded-md h-9" value={eventName} onChange={(e) => setEventName(e.target.value)} />
                    </div>

                    <div className="flex flex-col md:flex-row gap-2">
                        <label className="w-full md:w-[30%] text-left md:text-right">From:</label>
                        <input type="date" className="flex-1 p-2 border rounded-md h-9" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    </div>

                    <div className="flex flex-col md:flex-row gap-2">
                        <label className="w-full md:w-[30%] text-left md:text-right">To:</label>
                        <input type="date" className="flex-1 p-2 border rounded-md h-9" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </div>
                </div>

                <div className="
                flex
                flex-col
                md:flex-row
                justify-center
                gap-3
                pt-4
                border-t
                mt-4
                ">
                    <button type="submit" className="w-full md:w-auto px-12 py-2 bg-[#2563EB] text-white text-xs font-bold uppercase tracking-wider rounded-md hover:bg-blue-800 transition-all shadow-md active:scale-95">
                        Search
                    </button>
                </div>
            </form>

            <div
            className="
            w-full
            bg-white
            rounded-xl
            shadow-sm
            overflow-visible
            md:overflow-hidden
            border
            "
            >
                <div className="hidden md:block">

                <TableContainer
                    key={tableKey}
                    columns={tableHeaders}
                   
                    apiUrl={`admin/event-payments/?status=${filterType}&event_name=${eventName}&from_date=${fromDate}&to_date=${toDate}`}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    customActions={
                            <button onClick={handlePrintGridAction} className="px-6 py-1.5 bg-[#2563EB] text-white font-semibold text-xs rounded hover:bg-blue-800 shadow-md">
                                Print
                            </button>
                        }
                    searchPlaceholder="Search by order ID or Email..."
                    renderRow={(tx, index, srNo) => (
                        <tr key={tx.paymentdataid} className="border-b hover:bg-gray-50 text-xs font-medium text-gray-700">
                            <td className="py-3 px-2 border-r text-center">{srNo}</td>
                            <td className="py-3 px-2 border-r text-center">{tx.createddate}</td>
                            <td className="py-3 px-2 border-r font-mono">{tx.order_id || 'N/A'}</td>
                            <td className="py-3 px-2 border-r">{tx.cust_id}</td>
                            <td className="py-3 px-2 border-r font-bold">{tx.event_name || 'N/A'}</td>
                            <td className="py-3 px-2 border-r text-center">{tx.eventid}</td>
                            <td className="py-3 px-2 border-r text-right text-blue-900 font-bold">₹{parseFloat(tx.txn_amount || 0).toFixed(2)}</td>
                            <td className="p-3 border-r text-center">
                                {tx.paymentstatus === 'PENDING' ? (
                                    <button
                                        onClick={async () => {
                                            if (!window.confirm(`Approve payment for ${tx.cust_id}?`)) return;
                                            try {
                                                const token = localStorage.getItem('access_token');
                                                await API.post(`admin/approve-event-payment/`, { paymentdataid: tx.paymentdataid }, { headers: { 'Authorization': `Bearer ${token}` } });
                                                toast.success("Approved!");
                                                setTableKey(prev => prev + 1); 
                                            } catch (err) {
                                                toast.error("Failed!");
                                            }
                                        }}
                                        className="bg-yellow-100 text-yellow-800 border border-yellow-400 px-3 py-1 rounded text-[10px] font-bold uppercase animate-pulse"
                                    >
                                        PENDING
                                    </button>
                                ) : (
                                    <span className="bg-green-100 text-green-800 border border-green-400 px-3 py-1 rounded text-[10px] font-bold uppercase">SUCCESS</span>
                                )}
                            </td>
                        </tr>
                    )}
                />
                </div>

                <div className="md:hidden mt-4">

                <input
                type="text"
                value={searchQuery}
                onChange={(e)=>setSearchQuery(e.target.value)}
                placeholder="Search transaction..."
                className="
                w-full
                border
                rounded-lg
                p-3
                text-sm
                outline-none
                focus:border-blue-500
                "
                />

                </div>
                <div className="md:hidden space-y-4 mt-4">

            {
            loadingCards ?

            <div className="text-center py-10">

            Loading...

            </div>

            :

            list.length===0 ?

            <div className="text-center py-10">

            No Record Found

            </div>

            :

            list.map((tx)=>(

            <div
            key={tx.paymentdataid}
            className="
            bg-white
            rounded-xl
            border
            shadow-sm
            p-4
            w-full
            max-w-full
            min-w-0
            overflow-hidden
            "
            >

            <div className="space-y-3">

            <div>

            <p className="text-xs text-gray-500">

            Date

            </p>

            <p>{tx.createddate}</p>

            </div>

            <div>

            <p className="text-xs text-gray-500">

            Order ID

            </p>

            <p className="break-all">

            {tx.order_id}

            </p>

            </div>

            <div>

            <p className="text-xs text-gray-500">

            User

            </p>

            <p>{tx.cust_id}</p>

            </div>

            <div>

            <p className="text-xs text-gray-500">

            Event

            </p>

            <p>{tx.event_name}</p>

            </div>

            <div>

            <p className="text-xs text-gray-500">

            Amount

            </p>

            <p>

            ₹{parseFloat(tx.txn_amount||0).toFixed(2)}

            </p>

            </div>

            <div>

            <p className="text-xs text-gray-500">

            Status

            </p>

            {
            tx.paymentstatus==="PENDING"

            ?

            <button
            onClick={async()=>{

            if(!window.confirm(
            `Approve payment for ${tx.cust_id}?`
            ))
            return;

            try{

            const token=localStorage.getItem(
            "access_token"
            );

            await API.post(

            `admin/approve-event-payment/`,

            {
            paymentdataid:tx.paymentdataid
            },

            {
            headers:{
            Authorization:`Bearer ${token}`
            }
            }

            );

            toast.success("Approved");

            loadEventTransactions(
            mobilePage,
            searchQuery
            );

            }catch{

            toast.error("Failed");

            }

            }}
            className="
            bg-yellow-100
            text-yellow-800
            px-3
            py-1
            rounded
            text-xs
            font-bold
            "
            >

            PENDING

            </button>

            :

            <span
            className="
            bg-green-100
            text-green-800
            px-3
            py-1
            rounded
            text-xs
            font-bold
            "
            >

            SUCCESS

            </span>

            }

            </div>

            </div>

            </div>

            ))

            }

            </div>
            <div className="md:hidden flex justify-between items-center py-5">

            <button
            disabled={mobilePage===1}
            onClick={()=>setMobilePage(p=>p-1)}
            className="
            px-4
            py-2
            border
            rounded
            disabled:opacity-40
            "
            >

            Previous

            </button>

            <span>

            Page {mobilePage}

            of

            {mobileTotalPages}

            </span>

            <button
            disabled={mobilePage===mobileTotalPages}
            onClick={()=>setMobilePage(p=>p+1)}
            className="
            px-4
            py-2
            border
            rounded
            disabled:opacity-40
            "
            >

            Next

            </button>

            </div>
            </div>
        </div>
    );
};

export default EventTransactionReport;